module.exports = __webpack_public_path__ + "static/media/cache-clear.7e4f86e4.svg";